import { __awaiter } from "tslib";
import { getBackLink, getWebtexts, isCustomerFormDisabled, } from "../../shared/models/api";
import { VisitorCheck } from "./customer.form.check.r";
import Loader from "@phoenixreisen/reacts/src/loader";
import VisitorDataForm from "./customer.form.data.r";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Model from "../../shared/models/model";
import Config from "../../../../config";
import striptags from "striptags";
export const CustomerForm = () => {
    var _a, _b;
    const navigate = useNavigate();
    const { html } = Config;
    const { schedule } = Model;
    const [wts, setWts] = useState(Model.webtexts);
    const [customer, setCustomer] = useState(Model.customer);
    const [errors, setDataFormErrors] = useState({});
    const [wasArleadyGuest, setWasAlreadyGuest] = useState(Model.wasAlreadyGuest);
    useEffect(() => {
        if (!Model.schedule) {
            navigate("/");
        }
    }, []);
    useEffect(() => {
        (() => __awaiter(void 0, void 0, void 0, function* () {
            const result = yield getWebtexts();
            setWts(result);
        }))();
    }, [wts]);
    if (!wts || !schedule) {
        return React.createElement(Loader, null);
    }
    return (React.createElement("section", { className: "visitor form" },
        React.createElement("h3", { className: "pt0" }, "Rechnungsdaten"),
        ((_a = schedule.schiff) === null || _a === void 0 ? void 0 : _a.hochsee) && wts.sb_kundenauthentifizierung_see && (React.createElement("div", { dangerouslySetInnerHTML: {
                __html: striptags(wts.sb_kundenauthentifizierung_see, html.allowed),
            } })),
        !((_b = schedule.schiff) === null || _b === void 0 ? void 0 : _b.hochsee) && wts.sb_kundenauthentifizierung_fluss && (React.createElement("div", { dangerouslySetInnerHTML: {
                __html: striptags(wts.sb_kundenauthentifizierung_fluss, html.allowed),
            } })),
        React.createElement(VisitorCheck, { setCustomer: setCustomer, wasAlreadyGuest: wasArleadyGuest, setWasAlreadyGuest: setWasAlreadyGuest, setDataFormErrors: setDataFormErrors, backlink: getBackLink(schedule, "customer") }),
        (wasArleadyGuest === false || isCustomerFormDisabled()) && (React.createElement(VisitorDataForm, { errors: errors, customer: customer, setCustomer: setCustomer, setDataFormErrors: setDataFormErrors, backlink: getBackLink(schedule, "customer") }))));
};
export default CustomerForm;
